











import { Component, Vue } from 'vue-property-decorator';

@Component({components: {}})
export default class Home extends Vue {
  /**
   *
   */
  constructor() {
    super();
  }
  public async created() {
            // 1
        }
        public async mounted() {
            // 2
        }
}
